/**
 * AttachmentUploader - DirectUpload and file type handling
 * AI chat file attachment logic
 */

import { DirectUpload } from "@rails/activestorage"

/** Supported attachment types */
export const ATTACHMENT_TYPES = {
  IMAGE: 'image',
  PDF: 'pdf',
  WORD: 'word'
}

/**
 * Get attachment type from file MIME type
 */
export function getAttachmentType(file) {
  if (file.type?.startsWith('image/')) return ATTACHMENT_TYPES.IMAGE
  if (file.type === 'application/pdf') return ATTACHMENT_TYPES.PDF
  if (file.type === 'application/msword' ||
      file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
    return ATTACHMENT_TYPES.WORD
  }
  return ATTACHMENT_TYPES.PDF
}

/**
 * Upload a file with DirectUpload
 */
export function uploadWithDirectUpload(file, directUploadUrl) {
  return new Promise((resolve, reject) => {
    const upload = new DirectUpload(file, directUploadUrl, {
      directUploadWillStoreFileWithXHR: () => {}
    })
    upload.create((error, blob) => {
      if (error) reject(error)
      else resolve(blob)
    })
  })
}

/**
 * Create file entry object (before upload)
 */
export function createFileEntry(file, type, previewUrl = null) {
  return {
    file,
    signedId: null,
    filename: file.name,
    contentType: file.type,
    type,
    previewUrl,
    status: 'uploading'
  }
}

/**
 * Processed files → blob signed IDs
 */
export function getBlobSignedIds(selectedFiles) {
  return (selectedFiles || [])
    .filter(e => e.signedId && e.status === 'done')
    .map(e => e.signedId)
}

/**
 * Display format for chat messages (preview, filename, signed_id for linking)
 */
export function getAttachmentsForDisplay(selectedFiles) {
  return (selectedFiles || [])
    .filter(e => e.signedId && e.status === 'done')
    .map(e => ({
      type: e.type,
      filename: e.filename,
      preview_url: e.previewUrl || null,
      signed_id: e.signedId
    }))
}

/**
 * Check if any attachments are ready
 */
export function hasReadyAttachments(selectedFiles) {
  return selectedFiles?.some(e => e.signedId && e.status === 'done') ?? false
}

/**
 * Check if any uploads are in progress
 */
export function hasPendingUploads(selectedFiles) {
  return selectedFiles?.some(e => e.status === 'uploading') ?? false
}

/**
 * Check if any uploads failed
 */
export function hasFailedUploads(selectedFiles) {
  return selectedFiles?.some(e => e.status === 'error') ?? false
}
